import React, { PropTypes } from 'react';
import classnames from 'classnames';

import './style.scss';

const UserAvatar = (props) => {
  const className = classnames({
    'user-avatar': true,
    'is-empty': !!props.isEmpty,
    'has-image': !!props.imageUrl,
    [`${props.size}`]: !!props.size
  });

  return (
    <div className={className}>
      {(() => {
        if(props.imageUrl) {
          return <img src={props.imageUrl} />;
        }
        else {
          return <span>{props.letter}</span>;
        }
      })()}
    </div>
  );
};


UserAvatar.propTypes = {
  imageUrl: PropTypes.string,
  isEmpty: PropTypes.bool,
  letter: PropTypes.string,
  size: PropTypes.string
};

export default UserAvatar;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/UserAvatar/index.js
 **/